import { render, staticRenderFns } from "./dynamic-form-dialog.vue?vue&type=template&id=327eb65a&scoped=true&"
import script from "./dynamic-form-dialog.vue?vue&type=script&lang=js&"
export * from "./dynamic-form-dialog.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-form-dialog.vue?vue&type=style&index=0&id=327eb65a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327eb65a",
  null
  
)

export default component.exports